export default function SvgLive() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="26"
      viewBox="0 0 33 26"
      fill="none"
    >
      <rect x="1" y="1" width="31" height="20" rx="3" fill="black" />
      <rect x="9" y="23" width="16" height="2" rx="1" fill="black" />
    </svg>
  );
}
